import { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const NotificationListRowSkeleton: FC = () => (
  <Box sx={{ px: 1.5, py: 1.25 }}>
    <Stack spacing={0.75}>
      <Skeleton width="45%" height={16} />
      <Skeleton width="30%" height={12} />
      <Skeleton width="95%" height={14} />
      <Skeleton width="80%" height={14} />
    </Stack>
  </Box>
);
